import { useEffect } from "react"
import { DadosContainerDefault } from "../../components/Styles"
import { ModelosProcessosProvider } from "../../contexts/ModelosProcessos"
import ModelosProcessosPage from "../../components/ModelosProcessos"
import Permissoes from "../../middleware/Permissoes"

function ModelosProcessos () {

    useEffect (() => {
        document.title = 'Modelos de Processos | Gesttor'
    }, [])
    
    return (
        <ModelosProcessosProvider>
            <DadosContainerDefault>
                <Permissoes permissoes={['master', 'administrativo', 'processo_modelos']}>
                    <ModelosProcessosPage />
                </Permissoes>
            </DadosContainerDefault>
        </ModelosProcessosProvider>
    )
}

export default ModelosProcessos
